import { jsxs as o, jsx as i } from "react/jsx-runtime";
import { useTranslation as N } from "react-i18next";
import e from "./station-row.module.less.js";
import { getLogoForStation as h, getLabelForStationType as b } from "../../../helpers/station-data-resolvers.js";
const u = ({
  name: s,
  streetAdress: c,
  distanceInKm: a,
  stationType: l,
  hasElectricalCharging: n,
  onClickStation: d,
  isSelected: m,
  stationConcept: t
}) => {
  const { t: r } = N();
  return /* @__PURE__ */ o("button", { className: `${e.wrapper} ${m ? e.selected : ""}`, onClick: () => d(), children: [
    /* @__PURE__ */ o("div", { className: e.leftColumn, children: [
      l && /* @__PURE__ */ i("div", { className: e.logoWrapper, children: h(l, t) }),
      /* @__PURE__ */ o("div", { className: e.text, children: [
        s && /* @__PURE__ */ i("div", { className: [e.name, "body-base bold mb-0"].join(" "), children: s.toLowerCase() }),
        /* @__PURE__ */ i("div", { className: e.infoRow, children: /* @__PURE__ */ o("div", { className: "mb-0", children: [
          c,
          l ? " • " : "",
          l ? b(l, r) : ""
        ] }) })
      ] })
    ] }),
    /* @__PURE__ */ o("div", { className: e.rightColumn, children: [
      a && /* @__PURE__ */ o("div", { className: [e.distance, "body-s mb-0"].join(" "), children: [
        a,
        " ",
        r("FIND_STATION_KM_ABBREVIATED")
      ] }),
      n && /* @__PURE__ */ i("span", { className: ["ui-icon-bolt-filled", e.chargingIcon].join(" ") })
    ] })
  ] });
};
export {
  u as StationRow,
  u as default
};
